import React, { useEffect, useContext } from "react";
import "../assets/css/Registro.css";
import Contexto from "../context/Contexto";

const Restablecer = (props) => {
  const { resetPassword } = useContext(Contexto);
  let handleClick = () => {
    let email = document.getElementsByName("emailRes")[0].value;
    resetPassword(email);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <div className="soporteLogin">
        <div className="login">
          <div className="login__wrapper login__wrapperBig centrarTexto">
            <p className="titFelicitaciones">Cambiar contraseña</p>

            <input
              type="text"
              placeholder="Ingresá tu email"
              name="emailRes"
              className="formuCC largo"
            />

            <button className="formuBT" onClick={handleClick}>
              Cambiar contraseña
            </button>
            <p>
              Revisá tu email, incluido spam y promociones para encontrar el
              link de cambio.
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Restablecer;
